var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useCallback, useState } from "react";
import styled from "styled-components";
import { Button } from "../Form";
import { useTranslation } from "react-i18next";
import { getClassName } from "../../helpers";
import { APPOINTMENT_LIST, SHOW_LESS, SHOW_MORE, SHOW_MORE_TOGGLE } from "../../classConstants";
var APPOINTMENT_LIST_COLLAPSED_COUNT = 2;
export var AppointmentsList = memo((function (_a) {
    var data = _a.data, placement = _a.placement, props = __rest(_a, ["data", "placement"]);
    var t = useTranslation().t;
    var _b = useState(true), collapsed = _b[0], setCollapsed = _b[1];
    var handleToggle = useCallback(function () {
        setCollapsed(function (bool) { return !bool; });
    }, []);
    if (!(data === null || data === void 0 ? void 0 : data.length))
        return React.createElement("span", __assign({}, props));
    var showToggle = data.length > APPOINTMENT_LIST_COLLAPSED_COUNT;
    var list = !showToggle || !collapsed ? data : data.slice(0, APPOINTMENT_LIST_COLLAPSED_COUNT);
    var renderButton = function () {
        var _a;
        if (!showToggle)
            return null;
        var label = collapsed
            ? t(placement + ".show_more", { count: data.length - APPOINTMENT_LIST_COLLAPSED_COUNT })
            : t(placement + ".show_less");
        return React.createElement(Button, { label: label, variant: "clear", onClick: handleToggle, className: getClassName(SHOW_MORE_TOGGLE, (_a = {},
                _a[SHOW_LESS] = !collapsed,
                _a[SHOW_MORE] = collapsed,
                _a)) });
    };
    return (React.createElement("span", __assign({}, props),
        React.createElement(StyledList, { className: APPOINTMENT_LIST }, list.map(function (appointment) { return React.createElement("li", { key: appointment }, appointment); })),
        renderButton()));
}));
var StyledList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0;\n    padding: var(--ws-appointment-padding, 0 0 0 20px);\n"], ["\n    margin: 0;\n    padding: var(--ws-appointment-padding, 0 0 0 20px);\n"])));
var templateObject_1;
